// @flow
const AdTagType: {[type: string]: string} = {
  VAST: 'vast',
  VMAP: 'vmap'
};

export {AdTagType};



// WEBPACK FOOTER //
// ./ads/ad-tag-type.js


// WEBPACK FOOTER //
// core/ads/ad-tag-type.js